import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { computed } from 'vue'
interface Props {
  symbol: string
}

export default /*#__PURE__*/_defineComponent({
  props: {
    symbol: null
  },
  setup(__props: any) {

const props = __props as {
  symbol: string
}

const tokenListHasLogo = [
  'wbtc',
  'vrt',
  'usdt',
  'usdc',
  'uni',
  'sos',
  'eth',
  'dai',
  'ar',
  'ardrive',
  'xyz',
  'glmr',
  'dodo',
  'mask',
  'bank',
  'zlk',
  'cfx',
  't4ever',
  'fox',
  'bnb',
  'lat',
  'xsgd',
  'tar',
  'tusdc',
  'tardrive',
  'arg',
  'fra',
  'acnh'
]

const logonName = computed(() => {
  if (props.symbol && tokenListHasLogo.some(name => name === props.symbol.toLowerCase())) {
    return `${props.symbol.toLowerCase()}.png`
  } else {
    return 'default.svg'
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: require(`@/images/token/${_unref(logonName)}`),
    alt: "symbol"
  }, null, 8, _hoisted_1))
}
}

})